import { UserAuthListState } from '../state/userAuthListState'
import {
    FETCH_HEARTRUNNER_LIST_REQUEST1, FETCH_HEARTRUNNER_LIST_SUCCESS1, FETCH_HEARTRUNNER_LIST_ERROR,
   Fetch_All_Region_Data1,FETCH_AUTHTYPE_LIST_DATA,FETCH_AUTHMETHOD_LIST_DATA
} from '../action/userAuthListAction'

var initialStatusCode='' 

export function UserAuthListReducer(state = UserAuthListState , action) {
    
    switch (action.type) {
         case Fetch_All_Region_Data1:
                    return Object.assign({}, state, {
                        errorCode : action.errorCode,
                        statusCode : action.statusCode,
                        regionList : action.regionList
                    })
        case FETCH_HEARTRUNNER_LIST_REQUEST1:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                messageLabel:'',
                statusCode:initialStatusCode
         })
        case FETCH_HEARTRUNNER_LIST_SUCCESS1:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                heartRunnerList: action.heartRunnerList,
                statusCode : action.statusCode
            })
        case FETCH_HEARTRUNNER_LIST_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
      
       
           /*  case FETCH_REGION_LIST_DATA:
            return Object.assign({}, state, {
                regionList : action.list
            }) */
          case FETCH_AUTHTYPE_LIST_DATA:
            return Object.assign({}, state, {
                authenticationTypeList : action.list
            })
             case FETCH_AUTHMETHOD_LIST_DATA:
            return Object.assign({}, state, {
                authenticationMethodList : action.list
            })
        default:
            return state;
    }
}
